export default {
  translation: {
    common: {
      emailOrUsername: 'Email eller brugernavn',
      invalidUsernameOrPassword: 'Ugyldig brugernavn eller løsen',
      logInToBoards: 'Log på',
      noInternetConnection: 'Ingen forbindelse til internettet',
      pageNotFound_title: 'Side ej fundet',
      password: 'Løsen',
      serverConnectionFailed: 'Ingen forbindelse til serveren',
      unknownError: 'Ukendt fejl - prøv igen',
    },

    action: {
      logIn: 'Log på',
    },
  },
};
